import apuracaoDefinicaoPaineis from '@/produto/spa/apuracao-acao/apuracaoDefinicaoPaineis';

export default apuracaoDefinicaoPaineis;
